import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApplicationService } from 'src/app/services/application.service';
import { PrintService } from 'src/app/services/print.service';
import { ModalService } from 'src/app/services/modal.service';
import { ApplicationData } from 'src/app/data/application.data';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { LAYER_TYPE, LayerData } from 'src/app/data/configurator/layer/layer.data';
import { CoordUtil } from 'src/app/tools/coord.utils';
import { Rectangle } from 'src/app/tools/rectangle';
import { ContextData } from 'src/app/data/context.data';

@Component({
  selector: 'print-panel',
  templateUrl: './print-panel.component.html',
  host: {
    class: 'print-panel'
  }
})
export class PrintPanelComponent implements OnInit, OnDestroy {


  public overlapseControlProgress:string = "0/0";

  public vCalibInput:string;
  public hCalibInput:string;
  public vCalibInputError:boolean;
  public hCalibInputError:boolean;

  public langCode:string;

  /**
	 * Constructor
	 */
  constructor(
    public printService:PrintService,
    private applicationService: ApplicationService,
    private applicationData: ApplicationData,
    private modalService: ModalService,
    public translateService:TranslateService
  ) {
    this.langCode = translateService.currentLang.toUpperCase();
  }

  calibrate() {
    this.vCalibInputError = false;
    this.hCalibInputError = false;
    this.vCalibInput = this.printService.vPrintOffset.toString();
    this.hCalibInput = this.printService.hPrintOffset.toString();
    this.modalService.open('modal-print-calibration', {});
  }

  submitCalibrationInput(){
    let _numberRgx = /^-?\d*(\.\d+)?$/;
    this.vCalibInputError = !_numberRgx.test(this.vCalibInput);
    this.hCalibInputError = !_numberRgx.test(this.hCalibInput);
    if(!this.vCalibInputError && !this.hCalibInputError){
      this.printService.vPrintOffset = parseFloat(this.vCalibInput);
      this.printService.hPrintOffset = parseFloat(this.hCalibInput);
      this.modalService.cancel('modal-print-calibration');
    }
  }

	/**
	 * On init
	 */
  ngOnInit() {

  }

  goLabel(index:number) {
    this.applicationService.currentLayerData = null;
    this.applicationData.configuration.displayLabel(this.applicationData.configuration.labels[index]);
    this.modalService.cancel('modal-overlapse-results');
  }

  public labelWithOverlaps:number[];

  startOverlapseControl() :Observable<any> {

    return new Observable((observer) => {

      let _currentLabel = 0;
      this.labelWithOverlaps = [];

      let _controlNextLabel = () => {
        setTimeout(() => {
          this.applicationData.configuration.labels[_currentLabel].layers.map(layerData=>{
            if(this.labelWithOverlaps.indexOf(_currentLabel) >= 0) return;
            if(layerData.type == LayerData.TEXT){

              let _bb = CoordUtil.getRotatedRectangleBoundingBox(layerData.rotation, new Rectangle(
                layerData.x / ContextData.MM_TO_PIXELS,
                layerData.y / ContextData.MM_TO_PIXELS,
                layerData.width / ContextData.MM_TO_PIXELS,
                layerData.height / ContextData.MM_TO_PIXELS
              ));
              // console.log(_bb, [this.applicationData.configuration.labels[_currentLabel].width,this.applicationData.configuration.labels[_currentLabel].height]);
              if(_bb.x < 0){
                this.labelWithOverlaps.push(_currentLabel);
              } else if(_bb.y < 0){
                this.labelWithOverlaps.push(_currentLabel);
              } else if(_bb.x+_bb.width > this.applicationData.configuration.labels[_currentLabel].width){
                this.labelWithOverlaps.push(_currentLabel);
              } else if(_bb.y+_bb.height > this.applicationData.configuration.labels[_currentLabel].height){
                this.labelWithOverlaps.push(_currentLabel);
              }
            }
          });

          _currentLabel++;

          observer.next(_currentLabel+"/"+this.applicationData.configuration.labels.length);

          if(_currentLabel < this.applicationData.configuration.labels.length){
            _controlNextLabel();
          } else {
            observer.complete();
          }

        });

      };

      _controlNextLabel();


    });
  }

  controlOverlapse(onComplete:Function) {

    this.overlapseControlProgress = "0/"+this.applicationData.configuration.labels.length;

    this.modalService.open('modal-overlapse-control',{});

    this.startOverlapseControl().subscribe({
			next: (progress) => {
        this.overlapseControlProgress = progress;
			},
			error: (error) => {
        console.error(error);
        this.modalService.cancel('modal-overlapse-control');
			},
			complete: () => {
        this.overlapseControlProgress = this.applicationData.configuration.labels.length+"/"+this.applicationData.configuration.labels.length;
        this.modalService.cancel('modal-overlapse-control');
        if(this.labelWithOverlaps.length > 0){
          this.modalService.open('modal-overlapse-results',{
            onIgnore:()=>{
              this.modalService.cancel('modal-overlapse-results');
              onComplete();
            }
          });
        } else {
          onComplete();
        }
			}
    });

  }

  /**
   * Request print blank
   */
  requestPrintBlank() {
    if(this.applicationData.configuration.mustControlOverlapseBeforePrint){
      this.controlOverlapse(this.printBlank);
    } else {
      this.modalService.open('modal-print-advice', {func:()=>{this.printBlank()}});
    }
  }

  /**
   * Request print Elba
   */
  requestPrintElba() {
    if(this.applicationData.configuration.mustControlOverlapseBeforePrint){
      this.controlOverlapse(this.printElba);
    } else {
      this.modalService.open('modal-print-advice', { func: () => { this.printElba() } });
    }
  }

  /**
   * Print blank
   */
  printBlank = () => {
    this.printService.print(this.applicationData.configuration, true);
  }

  /**
   * Print elba
   */
  printElba = () => {
    this.printService.print(this.applicationData.configuration, false);
  }

	/**
	* On destroy
	*/
  ngOnDestroy() {

  }
}
